import React, { Component } from 'react'
import { Container, Toolbar, SearchField, Button, Label } from '@sencha/ext-modern'
import Message from 'tyan/components/Message'
import SearchBar from './SearchBar'
import ListItem from './ListItem'
import { WX } from 'tyan/public'

Ext.require([
    'Ext.dataview.listswiper.ListSwiper',
    'Ext.MessageBox'
])
const style = {
    outer: {
        backgroundColor: "#f5f5f5",
        paddingTop: "10px",
        paddingBottom: "10px"
    }
}
class InstrumentQuery extends Component {
    state = {
        query: this.props.match.params.query,//test0221 -> CE2A3E21099DF441EB0A92073042B609  http://localhost:1980/#/QYWX/InstrumentQuery/CE2A3E21099DF441EB0A92073042B609
        queryText: '',
        loading: false,
        errorMessage: null,
        instrumentList: null,
        pageCount: 10,
        page: 1,
        totalCount: 0
    }

    componentDidMount() {
        const { pageCount } = this.state
        this.GetInstrumentList(pageCount)
    }

    handleScanQRCode = () => {
        WX.scanQRCode({
            onScaned: ({ code }) => {
                this.setState({ query: code })
                this.handleSearch()
            }
        })
    }

    GetInstrumentList = (row) => {
        const { query } = this.state
        if (!query) {
            this.setState({ instrumentList: [], totalCount: 0 })
        } else {
            Tyan.doPostEvent('GetInstrumentListWx', {
                data: { row, query, },
                onRequest: () => {
                    this.setState({ loading: true })
                },
                onEnd: ({ errorMessage, queryText, instrumentList, totalCount }) => {
                    if (errorMessage) {
                        this.setState({ errorMessage })
                        return
                    }
                    this.setState({ loading: false, queryText, instrumentList, totalCount })
                }
            })
        }
    }

    handleLoadMore = () => {
        let { page, pageCount } = this.state
        page += 1
        this.GetInstrumentList(pageCount * page)
        this.setState({ page })
    }

    handleChange = (field, value) => {
        this.setState({ query: value })
    }

    handleSearch = () => {
        const { pageCount } = this.state
        this.GetInstrumentList(pageCount)
    }

    handleChildTap = (id) => {
        location.hash = /* /QYWX */ `/InstrumentInfo/${id}`
    }

    render() {
        const { errorMessage, instrumentList, query, queryText, totalCount } = this.state
        if (errorMessage) {
            return <Message text="数据加载失败" subText={errorMessage} />
        } else if (!instrumentList) {
            return <Message text="数据加载中..." />
        }

        return (
            <Container layout={{ type: "vbox" }} style={style.outer} scrollable >
                {/* {<SearchBar handleChange={this.handleChange} handleSearch={this.handleSearch} query={query} placeholder={"设备编号"} />} */}
                <Toolbar shadow={false} docked="top" padding="0" margin="0">
                    <SearchField ui="faded" placeholder="扫一扫" margin="0 20 0 20" value={queryText} readOnly={true} /* onChange={this.handleChange} */ />
                    <Button align="right" ui="action" iconCls={"x-fa fa-qrcode"} handler={this.handleScanQRCode} />
                </Toolbar>
                <ListItem dataList={instrumentList} totalCount={totalCount} handleLoadMore={this.handleLoadMore} handleChildTap={this.handleChildTap} />
            </Container>
        )
    }
}
export default InstrumentQuery